import store from "@/store";
import { ANPositionKeys } from "./DefaultObjects.js"

export function numberCellFormatter(params) {
  let isNumericData = params.colDef.field.length < 3
  let keys = isNumericData ? ANPositionKeys.numeric : ANPositionKeys.strings
  var finalNum = 0;
  var finalNumString;
  if (params.value === null) {
    return 0;
  } else if (params.value === " ") {
    return "";
  } else if (
    params.value % 2 == 0 ||
    params.value % 2 == 1 ||
    params.value % 2 == -1
  ) {
    finalNum = params.value.toFixed(0);
  } else if (params.value == undefined) {
    finalNum = "";
  } else {
    // If current node is a leaf node(has no children) then send its' parent into isGroupedBySymbol() instead of it self to prevent an 1 extra loop
    var roundPriceDigits = false;
    let digits;
    if (
      store.state.settings.applications.analytics.useDigitsField &&
      isPriceField(params.colDef.field, keys) &&
      decimalsCount(params.value) > 2 &&
      params.colDef
    ) {
      // If its a leaf node then check its' parent
      let nodeToCheck =
        !params.node.field && params.node.parent
          ? params.node.parent
          : params.node;
      
      if (isGroupedBySymbol(nodeToCheck, keys) || isLeafNode(params.node.field, params.node.level)) {
        let data = params.node.group ? params.node.aggData : params.node.data;
        if (data[keys.Digits]) {
          digits = data[keys.Digits];
          roundPriceDigits = true;
        }
      }
    }
    if (roundPriceDigits) finalNum = params.value.toFixed(digits);
    else finalNum = params.value.toFixed(2);
  }

  // Adds commas between thousands for better readability
  let thousandsSeperatorsRegex;
  // Use appropriate regex if the number has decimals
  thousandsSeperatorsRegex = roundPriceDigits
    ? /\d{1,3}(?=(\d{3})+(?=\.))/g
    : /(\d)(?=(\d{3})+(?!\d))/g;

  finalNumString = finalNum.toString().replace(thousandsSeperatorsRegex, "$1,");
  return finalNumString;
}

export function sortByAbs(val1, val2) {
  if (val1 === null && val2 === null) {
    return 0;
  }
  if (val1 === null) {
    return -1;
  }
  if (val2 === null) {
    return 1;
  }
  return Math.abs(val1) - Math.abs(val2);
}

// Helper Functions

function isGroupedBySymbol(node, keys) {

  // !field means that this is not a group since field is the name of the group
  // !parent means that this node is not a child of a group
  if (!node.field && !node.parent) return false;
  
  // node.level is the level of grouping e.g if table is only grouped by symbol then that symbol group is level 0 (table root is always level -1)
  let rootReached = node.level < 1;
  let groupedBySymbol = isSymbolField(node.field, keys)
  let currentNode = node;
  while (!rootReached && !groupedBySymbol) {
    if (isSymbolField(currentNode.field, keys)) {
      groupedBySymbol = true;
      break;
    }
    
    if (currentNode.level < 1) {
      rootReached = true;
    } else {
      currentNode = currentNode.parent;
    }
  }
  return groupedBySymbol;
}

function isLeafNode(field, level) {
  // field is the name of grouping
  return !field
}

function decimalsCount(value) {
  if (Math.floor(value) === value) return 0;
  return value.toString().split(".")[1].length || 0;
}

function isPriceField(field, keys) {
  return field == keys.BuyPrice || field == keys.SellPrice
}

function isSymbolField(field, keys) {
  return field == keys.Symbol || field == keys.PlainSymbol
}